module.exports = __webpack_public_path__ + "static/img/246_TO8_2197_og.f64e4c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/246_TO8_2197_og.jpg
// module id = I+8b
// module chunks = 0